import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ChatwootBootstrap from "./components/ChatwootBootstrap";
// SaleSmartly（暂时停用，保留以便恢复）
// import SaleSmartlyBootstrap from "./components/SaleSmartlyBootstrap";
// import SaleSmartlyFloatingButton from "./components/SaleSmartlyFloatingButton";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ChatwootBootstrap />
        {/* <SaleSmartlyBootstrap /> */}
        {/* <SaleSmartlyFloatingButton /> */}
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
